import {
  APARTMENT_PICKUP_LOCATION,
  SARAJEVO_INTL_AIRPORT,
} from "../constants";

const PICKUP_LABEL_KEYS = {
  [SARAJEVO_INTL_AIRPORT]: "pickupAirport",
  [APARTMENT_PICKUP_LOCATION]: "pickupApartment",
};

export const getCityDisplayName = (city, t) =>
  t(`tours.cities.${city}`, { ns: "home", defaultValue: city });

export const getCityDualDisplayName = (city, t, language) => {
  if (!city) return "";
  const localizedName = getCityDisplayName(city, t);
  if (language === "ar" && localizedName !== city) {
    return `${localizedName} (${city})`;
  }
  return localizedName;
};

export const getPickupLocationDisplayName = (location, t) => {
  const labelKey = PICKUP_LABEL_KEYS[location];
  if (!labelKey) return location;
  return t(`tours.builder.${labelKey}`, { ns: "home", defaultValue: location });
};

export const getTripDisplay = (trip, t, language) => {
  const id = trip?.id;
  if (id && language === "ar") {
    const desc = t(`tours.tripOptions.${id}.description`, {
      defaultValue: trip.description,
    });
    const attrs = t(`tours.tripOptions.${id}.attractions`, {
      returnObjects: true,
      defaultValue: trip.attractions,
    });
    if (desc && Array.isArray(attrs)) {
      return { description: desc, attractions: attrs };
    }
  }
  return {
    description: trip?.description || "",
    attractions: trip?.attractions || [],
  };
};
